// extracted by mini-css-extract-plugin
module.exports = {"container":"legend_container__25tRa","title":"legend_title__2GYlO","rating":"legend_rating__2HRho"};